class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }

}

customElements.define('cart-remove-button', CartRemoveButton);


class UpdateCart extends HTMLElement {
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}


class CartItems extends UpdateCart {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartFooter = document.getElementById('main-cart-footer');
        let totalPrice = parsedState.total_price;
        let applicable = false;
          parsedState.discount_codes.map(code => {
          if (code.applicable) {
            applicable = true;
          }
        });
        if (!applicable) {
          Shopify.setUsingCode(null);
        } else {
          Shopify.setUsingCode(true);
        }
        window.dispatchEvent(new CustomEvent("show-info-popup", { detail: { total: totalPrice } }));
        this.toggleAttribute("is-empty", parsedState.item_count === 0)

        if (cartFooter) cartFooter.toggleAttribute('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

      }).catch((e) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const error = [
        '<div class="flex space-x-2 bg-red bg-opacity-10 text-red p-2 text-xs">',
        '<svg class="block w-5 h-5 text-red" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 13 13">',
        '<circle cx="6.5" cy="6.5" r="5.5" fill="currentColor" stroke="currentColor" stroke-width="0.7"></circle>',
        '<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="currentColor" stroke-width="0.7">',
        '</path></svg>',
        '<span>',
        window.cartStrings.quantityError.replace('[quantity]', document.getElementById(`Quantity-${line}`).value),
        '</span>',
        '</div>'
      ];

      document.getElementById(`Line-item-error-${line}`).innerHTML = error.join("");
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class CouponBlock extends UpdateCart {
  constructor() {
    super();
    this.disableButton = false;
    this.input = this.querySelector('input');
    this.input.addEventListener('keyup',this.checks.bind(this))
    this.label = this.querySelector('#managecoupon');
    this.label.addEventListener("click", this.toogle.bind(this));
    this.coupon = this.querySelector("#coupon-bl");
    this.buttonText = this.querySelector("#original_text_button");
    this.buttonLoader = this.querySelector("#loader_button");
    this.querySelector('button#apply-discount').addEventListener('click', this.apply.bind(this));
    if (this.querySelector('button#remove-discount') != null) {
      this.querySelector('button#remove-discount').addEventListener('click', this.remove.bind(this));
    }
    if (Shopify.getUsingCode() == false) {
          this.coupon.classList.remove("hidden");
           this.querySelector("#span_error").innerHTML = 'Discount code does not apply on products in your cart';
           this.showErrors();
    }
  }
  checks(event) {
    this.hideErrors();
    this.disableButton = this.input.value.length > 0 ? false : true;
    this.querySelector('button#apply-discount').disabled = this.disableButton ;
    if (this.disableButton) {
      this.querySelector('button#apply-discount').classList.remove('btn-primary');
      this.querySelector('button#apply-discount').classList.add('btn-secondary');
    } else {
      this.querySelector('button#apply-discount').classList.remove('btn-secondary');
      this.querySelector('button#apply-discount').classList.add('btn-primary');
    }
  }

  toogle (event) {
       event.preventDefault();
    if (this.coupon.classList.contains("hidden")) {
       this.coupon.classList.remove("hidden");
    } else {
      this.coupon.classList.add("hidden");
    }
  }
  async apply(event) {
    event.preventDefault();
    this.enableLoading();
    let result = await this.fetchDiscounts(this.input.value);
    if (result == true) {
      this.fetchingData(this.input.value);
    } else {
      this.showErrors();
      this.disableLoading();
    }
  }

  remove(event) {
    event.preventDefault();
    this.enableLoading();
    this.fetchingData('', true)

  }

  fetchingData(code, isRemove = false) {
    const body = JSON.stringify({
      discount: code,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        let totalPrice = parsedState.total_price;
        let applicable = false;
        parsedState.discount_codes.map(code => {
          if (code.applicable) {
            applicable = true;
          }
        });
        if (!applicable && !isRemove) {
          Shopify.setUsingCode(false);
        } else {
          Shopify.setUsingCode(true);
        }
        window.dispatchEvent(new CustomEvent("show-info-popup", { detail: { total: totalPrice } }));
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        
      

      }).catch((e) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
      }).finally(()=> {
        this.disableLoading();
      });
  }

  async fetchDiscounts(code) {
    const response = await fetch("/apps/proxy_app/discounts", {
      method: "POST",
      redirect: "manual",
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify({ "coupon": code })
    });
    if (!response.ok) {
      console.error("Failed to fetch discounts");
      return [];
    }
    const discounts = await response.json();

    return discounts.status;
  }

  showErrors() {
    this.querySelector("#span_error").classList.remove("hidden");
    this.input.classList.add("border-red");
  }

  hideErrors() {
    this.querySelector("#span_error").innerHTML = 'Coupon code is invalid';
    this.querySelector("#span_error").classList.add("hidden");
    this.input.classList.remove("border-red");
  }

  enableLoading() {
    this.buttonText.classList.add('hidden');
    this.buttonLoader.classList.remove('hidden');
   
  }

  disableLoading() {
     this.buttonLoader.classList.add('hidden');
    this.buttonText.classList.remove('hidden');
   
  }


}

customElements.define('coupon-block', CouponBlock);
